import {
  QueryBuilderEntityConfigType,
  QueryBuilderEntityValueOptionType,
  QueryBuilderInputContextType,
  QueryBuilderOperatorType,
} from '../../../../types';
import { filterEntityOptionsBySearch } from '../filterEntityOptionsBySearch';
import { filterOperatorsBySearch } from '../filterOperatorsBySearch';
import { filterValueOptionsBySearch } from '../filterValueOptionsBySearch';

type GetSuggestionOptionsArgsType = {
  context: QueryBuilderInputContextType;
  entities: QueryBuilderEntityConfigType[];
  search: string;
  valueOptions: QueryBuilderEntityValueOptionType[];
};

type GetSuggestionOptionsReturnType = {
  entityOptions: QueryBuilderEntityConfigType[];
  filteredEntityOptions: QueryBuilderEntityConfigType[];
  filteredOperatorOptions: QueryBuilderOperatorType[];
  filteredValueOptions: QueryBuilderEntityValueOptionType[];
  valueOptionsForContext: QueryBuilderEntityValueOptionType[];
};

export const getSuggestionOptions = ({
  context,
  entities,
  search,
  valueOptions,
}: GetSuggestionOptionsArgsType): GetSuggestionOptionsReturnType => {
  const entityOptions = context === 'expectOperand' ? entities : [];
  const filteredEntityOptions = filterEntityOptionsBySearch(
    entityOptions,
    search
  );
  const filteredOperatorOptions =
    context === 'expectOperatorOrClose' ? filterOperatorsBySearch(search) : [];
  const valueOptionsForContext = context === 'expectValue' ? valueOptions : [];
  const filteredValueOptions = filterValueOptionsBySearch(
    valueOptionsForContext,
    search
  );

  return {
    entityOptions,
    filteredEntityOptions,
    filteredOperatorOptions,
    filteredValueOptions,
    valueOptionsForContext,
  };
};
